import { createFileRoute, redirect } from '@tanstack/react-router'
import { HTTPError } from 'ky'
import { bootstrapQueryOptions } from '@/features/bootstrap/api/bootstrap/queries/bootstrap-query'
import {
  getBootstrapWorkspace,
  getBootstrapWorkspaceRefs,
  getGtmWorkspaceRefs,
  getWorkspaceEntryRoute,
} from '@/features/bootstrap/domain/bootstrap-workspaces'
import { getNoWorkspacesEntryRoute } from '@/features/bootstrap/domain/bootstrap-entry'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import { getPreferredWorkspaceRoute } from '@/features/chats/domain/use-workspace-chat-shell-domain'
import { getApiErrorCode } from '@/shared/api/errors'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'

export const Route = createFileRoute('/$lang/app')({
  beforeLoad: async ({ context, params }) => {
    requireAuthenticated(context, params)

    let bootstrap
    try {
      bootstrap = await context.queryClient.fetchQuery(bootstrapQueryOptions())
    } catch (error) {
      if (error instanceof HTTPError && error.response.status === 403) {
        const code = await getApiErrorCode(error)
        if (code === 'PENDING_APPROVAL_REQUIRED') {
          throw redirect({
            to: '/$lang/pending-approval',
            params: { lang: params.lang },
            replace: true,
          })
        }
      }
      throw error
    }

    // GTM product: only workspaces with the GTM employee are entry points.
    const workspaces = GTM_PRODUCT_SCOPE.legacyWorkspaceUi
      ? getBootstrapWorkspaceRefs(bootstrap.workspaces)
      : getGtmWorkspaceRefs(bootstrap.workspaces)

    if (workspaces.length === 0) {
      throw redirect({
        to: getNoWorkspacesEntryRoute(bootstrap),
        params: { lang: params.lang },
        replace: true,
      })
    }

    const workspaceId = getPreferredWorkspaceRoute(workspaces)

    if (!workspaceId) {
      throw redirect({
        to: getNoWorkspacesEntryRoute(bootstrap),
        params: { lang: params.lang },
        replace: true,
      })
    }

    const workspace = getBootstrapWorkspace(workspaces, workspaceId)
    throw redirect({
      to: workspace
        ? getWorkspaceEntryRoute(workspace)
        : '/$lang/workspace/$workspaceId',
      params: { lang: params.lang, workspaceId },
      replace: true,
    })
  },
  component: () => null,
  staticData: { layout: 'main' },
})
